import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserPublicRoutingModule } from './user-public-routing.module';
import { UserPublicComponent } from './user-public.component';
import { LoginComponent } from './login/login.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [UserPublicComponent, LoginComponent],
  imports: [CommonModule, UserPublicRoutingModule, FormsModule],
})
export class UserPublicModule {}
